<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Subject Offering Import</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete rounded :items="ay_list" v-model="ay" item-text="ay" item-value="id"
                        label="Academic Year" dense outlined placeholder="Select Academic Year"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row justify="center" align="center" v-if="ay!=null">
                <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                    <v-file-input placeholder="CSV of Subject Offering" prepend-icon="mdi-file"
                        label="Subject Offering Data" rounded dense flat outlined show-size
                        v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                    <a
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/Import_Course_offering.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
                            class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                            Download import CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
            </v-row>

            <v-col cols="12" sm="12" md="12" v-if="load == true">
                <template v-if="load == true">
                    <v-data-table :headers="headers" :items="statuslist" sort-by class="elevation-1 mytable" dense
                        :search="search" :loading="output_load"></v-data-table>
                </template>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="show_scuuess_table">
                <template v-if="show_scuuess_table">
                    <v-data-table :headers="headers" :items="success_list" sort-by class="elevation-1 mytable" dense
                        :search="search" :loading="output_load"></v-data-table>
                </template>
            </v-col>

            <!-- shiv new code -->
            <v-col cols="12" sm="12" md="12">
                <template v-if="load == false && show_scuuess_table == false">
                    <v-simple-table class="mytable">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">CourseCode</th>
                                    <th class="text-left">Course Name</th>
                                    <th class="text-left">Standard</th>
                                    <th class="text-left">Grading Scheme</th>
                                    <th class="text-left">Course Rule</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>abc</td>
                                    <td>java</td>
                                    <td>x</td>
                                    <td>Marketing</td>
                                    <td>CP</td>
                                </tr>
                                <tr>
                                    <td class="mandatory">Mandatory</td>
                                    <td class="mandatory">Mandatory</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </template>
            </v-col>
            <!-- shiv code end -->
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

        /*
      Defines the data used by the component
    */
        data() {
            return {
                show_scuuess_table: false,
                success_list: [],
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                ay_list: null,
                ay: null,
                file: null,
                statuslist: "",
                load: false,
                loading3: false,
                search: "",
                headers: [
                    { text: "Sr.NO", value: "count" },
                    { text: "Course Offering", value: "courseOffering" },
                    { text: "Status", value: "status" },
                ],
                output_load: false,
            };
        },
        mounted() {
            axios
                .post("/InstallmentStructureDetails/importLearnerSelectionHome")
                .then((res) => {
                    this.ay_list = res.data.ay_list;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {});
        },
        methods: {
            submitFile() {
                if (this.file == null) {
                    alert("Please select the file!");
                } else {
                    this.output_load = true;
                    let formData = new FormData();
                    //console.log(this.file.size);
                    formData.append("file", this.file);
                    formData.append("ay", this.ay);

                    //console.log(formData)
                    axios
                        .post("Examination/importSubjectOffering", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.msg == "200") {
                                if (res.data.failstatuslist.length > 0) {
                                    // alert("ifff")
                                    this.statuslist = res.data.failstatuslist;
                                    this.load = true;
                                }
                                if (res.data.success_status_list.length > 0) {
                                    //  alert("if----2222")
                                    this.success_list = res.data.success_status_list;
                                    this.show_scuuess_table = true;
                                }
                            }
                        })
                        .catch(function () {
                            console.log("FAILURE!!");
                        })
                        .finally(() => {
                            this.output_load = false;
                        });
                }

                //     }
            },

            /*
        Handles a change on the file upload
      */
        },
    };
</script>
<style scoped>
    .downbtn {
        float: right;
    }

    /* new css */
    table,
    th {
        padding: 10px;
        border: 1px solid black;
        border-collapse: collapse;
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .mandatory {
        color: red;
    }
</style>
